module.exports = __webpack_public_path__ + "static/media/linkedIn.d059f7f0.svg";